import { render } from "./CommentForm.vue?vue&type=template&id=cd4c04e6"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__